import { useRouter } from "next/router";
import { useTranslation } from "@fanfanlo";

import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import CreateIcon from '@mui/icons-material/Create';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
interface TabInfoType {
  label: string;
  value: string;
  icon: React.ReactNode;
}

export function NavBar() {
  const router = useRouter();
  const { pathname } = router;
  const { t } = useTranslation('homepage/components/navbar/content');
  const tabInfoList: TabInfoType[] = [
    { label: t('NavBar.home'), value: '/', icon: <HomeIcon /> },
    { label: t('NavBar.create'), value: '/script-creator', icon: <CreateIcon /> },
    { label: t('NavBar.market'), value: '/fanfanlo/market', icon: <StorefrontIcon /> },
    { label: t('NavBar.settings'), value: '/settings', icon: <SettingsIcon /> },
  ];
  return (

    <BottomNavigation showLabels value={pathname}>
      {tabInfoList.map((e, index) => (
        <BottomNavigationAction
          key={e.value}
          label={e.label}
          icon={e.icon}
          data-testid={`NavBar__tabItem__01aryz6s610p4z0skjq69x5prs__${index}`}
          data-test-comment="导航栏标签项，点击后导航到对应页面（首页/脚本创建/设置）"
          className={pathname === e.value ? 'Mui-selected' : ''}
          onClick={() => {
            if (pathname === e.value) return;
            router.push(e.value);
          }}
        />
      ))}
    </BottomNavigation>
  );
}